import { Button, DatePicker, Form, Input, Select } from 'antd';
import moment from 'moment';
import React, { useEffect, useCallback } from 'react';
import ActionsComponent from 'src/components/shared/ActionsComponent';
import GridLayout from 'src/components/shared/gridLayout';
const { RangePicker } = DatePicker;
const Filters = (props) => {
  const [form] = Form.useForm()

   const disabledFutureDates = useCallback(
          (current) => current && current > moment().endOf('day'),
          []
        );

  useEffect(() => {
    form.setFieldsValue(props?.filterValues);
    if (props?.onloadGrid) {
      props.onloadGrid();
    }
  }, [props?.filterValues])
  const handleChange = useCallback((field) => (value) => {
    const trimmedValues = {
      ...form.getFieldsValue(),
      [field]: value
    };
    props?.filterObj(trimmedValues);
  }, [props, form]);
  const handleSearch = useCallback((values) => {
    let trimSearchData = values?.freeSearch?.trim();
    const invalidSearchPattern = /^[^\p{L}\p{N}]+$/u;
    if (!trimSearchData || invalidSearchPattern.test(trimSearchData)) {
      form.setFieldsValue({ ...values, freeSearch: null });
      props?.filterObj({ ...values, freeSearch: null });
      return;
    }
    const trimmedValues = {
      ...values,
      freeSearch: trimSearchData
    };
    props?.filterObj(trimmedValues);
  }, [props]);
  return (
    <div className='md:flex justify-between mt-3 mb-4 md:space-y-0 space-y-3'>
      <div className=''>
        <Form className="custom-filter-field"
          autoComplete="off"
          onFinish={handleSearch}
          form={form}>
          <div className='grid md:grid-cols-3 gap-4'>
            <Form.Item
              name="Status"
              className='!mb-0'
            >
              <Select
                className=""
                placeholder={`All Status`}
                onChange={handleChange("status")}
              >
                {props?.stateLu?.map((item) => (
                  <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="dateRange" className='!mb-0'>
              <RangePicker
                format="DD-MM-YYYY"
                onChange={handleChange("dateRange")}
                disabledDate={disabledFutureDates}
              /></Form.Item>
            <Form.Item
              className='input-style !mb-0'
              name="freeSearch"
            >
              <Input placeholder='Search by ID,Card Number,Email'
                suffix={<Button className='!bg-transparent border-none p-0 !hover:bg-transparent focus:bg-transparent focus:shadow-none' htmlType='submit'><span className="icon md search cursor-pointer"></span></Button>}
                className="coin-search-input" maxLength={50} />
            </Form.Item>
          </div>
        </Form>
      </div>
     <div className='flex items-center gap-2'>
       <ActionsComponent serviceName={"CardsManageService.Cards"} onActionClick={props?.handleExcelExport} />
       <GridLayout />
     </div>
    </div>
  )
}
export default React.memo(Filters);